import React from 'react';
import { Grid, Typography} from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import TextTransition, { presets } from "react-text-transition";

const TEXTS = [
  "Authentic.",
  "Creative.",
  "Unique.",
  "Innovative."
];

function WhoWeAreFeatured() {
  const globalClasses = globalUseStyles();
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(() =>
      setIndex(index => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
<ThemeProvider theme={theme}>
  <Container className={globalClasses.featuredContainer} maxWidth={false} component="section">
    <Grid className={globalClasses.containerSmall} container >
        <Grid item xs={12} md={12}  >
          <Typography variant="subtitle1">Who We Are</Typography>
         
          <Typography variant="h1">We are  <TextTransition
        text={ TEXTS[index % TEXTS.length] }
        springConfig={ presets.wobbly }
        style={{display: 'inline'}}
      /></Typography>
          <Typography variant="body1">We are a collaborative group of passionate technologists who love helping organizations use technology to the max.</Typography>
        </Grid>
    </Grid>
  </Container>
</ThemeProvider>
  );
};

export default WhoWeAreFeatured;